<template>
    <div class="footer">
        <div class="center">
            <div class="link">
                <div>
                    <h1>关于凯纳</h1>
                    <span><a href="javascript:void(0);" @click.stop="goTo('GongSiJianJie')">公司简介</a></span>
                    <span><a href="javascript:void(0);" @click.stop="goTo('SheHuiZeRen')">社会责任</a></span>
                    <!-- <span><a href="javascript:void(0);" @click.stop="goTo('ChengGongAnLi')">典型案例</a></span> -->
                </div>
                <div>
                    <h1>产品与服务</h1>
                    <span><a href="javascript:void(0);" @click.stop="goTo('RuanJianChanPin')">软件产品</a></span>
                    <span><a href="javascript:void(0);" @click.stop="goTo('YingJianChanPin')">硬件产品</a></span>
                    <span><a href="javascript:void(0);" @click.stop="goTo('ZhiNengShuiBiao')">智能水表</a></span>
                </div>
                <div>
                    <h1></h1>
                    <span><a href="javascript:void(0);" @click.stop="goTo('YunWeiFuWu')">运维服务</a></span>
                    <span><a href="javascript:void(0);" @click.stop="goTo('SheMiYeWuFuWu')">涉密业务服务</a></span>
                </div>
                <div>
                    <h1>解决方案</h1>
                    <span><a href="javascript:void(0);" @click.stop="goTo('ZhiHuiGongShui')">智慧供水</a></span>
                    <span><a href="javascript:void(0);" @click.stop="goTo('ZhiHuiPaiShui')">智慧排水</a></span>
                    <span><a href="javascript:void(0);" @click.stop="goTo('NongCunShengHuoWuShuiZhiLi')">污水治理</a></span>
                </div>
                <div>
                    <h1>客户与联盟</h1>
                    <span><a href="javascript:void(0);" @click.stop="goTo('WoMenDeKeHu')">我们的客户</a></span>
                    <span><a href="javascript:void(0);" @click.stop="goTo('KeHuYuLianMengView?id=16&customersType=602')">2026合作伙伴计划</a></span>
                </div>
                <div>
                    <h1>人才招聘</h1>
                    <span><a href="javascript:void(0);" @click.stop="goTo('XiaoYuanZhaoPin')">校园招聘</a></span>
                    <span><a href="javascript:void(0);" @click.stop="goTo('SheHuiZhaoPin')">社会招聘</a></span>
                </div>
            </div>
            <div class="qrcode"><img src="../assets/img/qr_code.png" alt="微信公众号" /><br />关注凯纳，了解更多</div>
        </div>
        <div class="icp"><span class="left">&copy; 版权所有 哈尔滨凯纳科技股份有限公司 <a href="https://beian.miit.gov.cn/" target="_blank">黑ICP备11005362</a></span><span class="right">服务专线：400-655-1155</span></div>
    </div>
</template>

<script>

export default {
    data() {
        return {
        }; 
    },
    created() {
    },
    mounted() {},
    methods: {
        goTo(e) {
            //跳转页面
            this.$router.push(e);
        },
    },
};
</script>

<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/components/PageFooter.vue